/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type MinimalUser = {
    id: number;
    title: string | null;
    gender: MinimalUser.gender;
    firstName: string;
    lastName: string;
    email: string;
    image: string | null;
    role: MinimalUser.role;
    isOwner: boolean;
    invitedAt: string | null;
    acceptedAt: string | null;
};
export namespace MinimalUser {
    export enum gender {
        MALE = 'male',
        FEMALE = 'female',
        DIVERSE = 'diverse',
        NOT_SET = 'not_set',
        DELETED = 'deleted',
    }
    export enum role {
        OWNER = 'owner',
        ADMIN = 'admin',
        PRACTITIONER = 'practitioner',
        ASSISTANT = 'assistant',
        VIEWER = 'viewer',
        THERAPIST = 'therapist',
        USER = 'user',
    }
}

